import { api } from "@/services";

async function useAsyncYearsByModel(model: string, brand: string) {
  let Data: any = null;
  let Error: string = null;

  if (!brand || !model) {
    return [Data, "Nenhuma marca ou modelo informado"];
  }

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp = await api.get(`/Vehicles/GetYearsCompositionsByBrandModel`, {
        signal: Controller.signal,
        params: {
          brand,
          model
        }
      });
      if (resp.data) {
        Data = resp.data;
      } else {
        Error = "Nenhum conteúdo encontrado";
      }
    } catch (Err) {
      Error = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Data, Error];
}

export { useAsyncYearsByModel };
